module.exports = __webpack_public_path__ + "img/banner-investor.7fc16aad.jpg";